"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgbWithAlphaInputs = exports.hexWithAlphaInputs = exports.defaultInputs = void 0;
const hexInput = {
  label: "Hex",
  propKey: "hex",
  width: 92,
  clientId: "clp-hex-input",
  allowedCharacters: "#0-9A-Fa-f",
  flexGrow: 2
};
const rgbInputs = [{
  label: "R",
  propKey: "r",
  width: 38,
  clientId: "clp-r-input",
  allowedCharacters: "0-9",
  flexGrow: 1
}, {
  label: "G",
  propKey: "g",
  width: 38,
  clientId: "clp-g-input",
  allowedCharacters: "0-9",
  flexGrow: 1
}, {
  label: "B",
  propKey: "b",
  width: 38,
  clientId: "clp-b-input",
  allowedCharacters: "0-9",
  flexGrow: 1
}];
const defaultInputs = [hexInput, ...rgbInputs];
exports.defaultInputs = defaultInputs;
const hexWithAlphaInputs = [{
  ...hexInput,
  width: 82,
  flexGrow: 1
}, {
  label: "Opacity",
  propKey: "a",
  width: 82,
  clientId: "clp-alpha-input",
  allowedCharacters: "%0-9",
  flexGrow: 1
}];
exports.hexWithAlphaInputs = hexWithAlphaInputs;
const rgbWithAlphaInputs = [...rgbInputs, {
  label: "Opacity",
  propKey: "a",
  width: 38,
  clientId: "clp-alpha-input",
  allowedCharacters: "%0-9",
  flexGrow: 1
}];
exports.rgbWithAlphaInputs = rgbWithAlphaInputs;
//# sourceMappingURL=inputs.js.map